<template>
  <div id="hotSwiper" class="pos-r pb10">
    <swiper :options="hotSwiper" v-if="initList && initList.length">
      <swiper-slide v-for="(item, index) of list" :key="index" class="flex jc-sb flex-w">
        <div v-for="(itemSon, indexSon) of item" :key="indexSon" class="pb20 item">
          <div class="pos-r">
            <img :src="itemSon.img_path" alt="" @click="goDetail(itemSon)" />
            <goods-float-img
              class="pos-a l0 r0 b0"
              v-if="itemSon.fullNFreeN && itemSon.fullNFreeN.bgimg"
              :fullNFreeN="itemSon.fullNFreeN"
              :mini-small-front="true"
            ></goods-float-img>
          </div>
          <p class="f13 color-29 fw-b over-ell-2 name mb6" @click="goDetail(itemSon)">
            {{ itemSon.name }}
          </p>
          <div class="flex ai-fe" @click="goDetail(itemSon)">
            <div class="flex ai-fe f10 color-FC0324" v-if="itemSon.sales_price">
              ¥
              <span class="f12">{{ showPrice(itemSon).split('.')[0] }}</span>
              .{{ showPrice(itemSon).split('.')[1] }}
            </div>
            <span class="f10 color-6 td-lt ml4" v-if="itemSon.cost_price">
              ¥{{ itemSon.cost_price }}
            </span>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination" id="swiperPagination"></div>
  </div>
</template>
<script>
import goodsFloatImg from '../../common/goodsFloatImg.vue'
import skufunc from '../../../assets/common/js/sku_func'
export default {
  components: {
    goodsFloatImg
  },
  props: {
    initList: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    markPointData: {
      // 埋点用
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      hotSwiper: {
        autoplay: false,
        autoplayDisableOnInteraction: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        pagination: {
          el: '#swiperPagination',
          type: 'bullets'
        }
      }
    }
  },
  methods: {
    showPrice(item) {
      var money = item.morediscounts && item.morediscounts.morediscountsmoney
      if (!(parseFloat(money) > 0)) return String(item.sales_price)
      return skufunc.cutMoreDiscount(item.sales_price, money).toFixed(2)
    },
    goDetail(item) {
      var id = item.itemid ? item.itemid : item.item_base_id
      var that = this
      if (this.type != 'lazyloading' && this.type != 'notScrollTo') {
        // window.scrollTo(0, 0)
      } else {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'indexprod-' + id
          },
          callback: () => {
            f()
          }
        })
        return
      }
      f()
      function f() {
        let data = that.markPointData
        data.scenepoint += '-' + id
        that.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: data
        })
        if (item.product_detail && item.product_detail == 1) {
          that.$router.replace({
            path: '/productdetail',
            query: {
              itemid: id
            }
          })
          that.$emit('itemid', id)
        } else {
          var arg = isApp()

          if (arg == '') {
            that.$router.push({
              path: '/productdetail',
              query: {
                itemid: id
              }
            })
          } else if (arg.indexOf('xcx') < 0) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'goItemDetail',
                itembaseid: id
              })
            )
          } else {
            wx.miniProgram.navigateTo({
              url:
                '/pages/product/main?itemid=' +
                id +
                '&exclusiveid=' +
                exclusiveidFn() +
                pointParams('&')
            })
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
#hotSwiper {
  .swiper-slide {
    font-size: 0;
    .item {
      width: 33.33%;
    }
    img {
      height: 1.04rem;
      object-fit: cover;
      margin-bottom: 0.08rem;
      border-radius: 0.08rem;
    }
    .name {
      min-height: 0.32rem;
    }
  }
  #swiperPagination {
    width: auto;
    font-size: 0;
    color: #ffffff;
    /*right: 0.21rem;*/
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    z-index: 1;
    /deep/ span {
      &.swiper-pagination-bullet {
        width: 0.11rem;
        height: 0.03rem;
        border-radius: 0.01rem;
        margin-left: 0;
        background: rbga(0, 0, 0, 0.2);
      }
      &.swiper-pagination-bullet-active {
        background: #7a7a7a;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productdetail/components/hotSalesGoods.vue